/**
 * S4 Magasin - Leaflet Map
 */

import L from "leaflet";
import "leaflet/dist/leaflet.css";

document.addEventListener("DOMContentLoaded", function () {
	const mapContainer = document.getElementById("store-map");

	if (mapContainer) {
		const lat = parseFloat(mapContainer.dataset.lat);
		const lng = parseFloat(mapContainer.dataset.lng);
		const storeName = mapContainer.dataset.name;

		if (!isNaN(lat) && !isNaN(lng)) {
			// Initialize Leaflet map with custom options
			const map = L.map("store-map", {
				scrollWheelZoom: false, // Désactiver le zoom au scroll
				attributionControl: true,
			}).setView([lat, lng], 15);

			// Configurer l'attribution
			map.attributionControl.setPosition("bottomleft");
			map.attributionControl.setPrefix(false); // Retirer le crédit Leaflet

			// Add OpenStreetMap tiles
			L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
				attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
				maxZoom: 19,
			}).addTo(map);

			// Créer une icône personnalisée avec le marqueur du thème
			const customIcon = L.divIcon({
				html: '<img src="/modules/s4_magasin/views/img/marker-store.svg" alt="Store marker" class="store-marker-svg">',
				className: "store-marker",
				iconSize: [42, 52],
				iconAnchor: [21, 52],
			});

			// Add marker sans popup
			L.marker([lat, lng], {
				icon: customIcon,
			}).addTo(map);
		}
	}
});
